import { Fieldset, If } from '@paytrace/pt-skel/Component'
import * as React from 'react'
import { getLegacyDomain } from '@paytrace/pt-skel/Helper'
import { useNavigate } from 'react-router-dom'
import { MANAGE_ENHANCED_DATA_PAGE_ROUTE } from '../../../Helper/EnhancedData/Constants'
import { AlertIcon } from '../../Icons/AlertIcon'
import { AmountsDisplay } from './AmountsDisplay'
import { ManageEnhancedDataBanner } from './ManageEnhancedDataBanner'
import { ResponseInformation } from './ResponseInformation'
import { SurchargeAmounts, TransactionPageProps } from './ResponsePage'
import { ViewAndEmailReceipt } from './SaveAndEmailReceipt'

export function ApprovedView ({ props, orderId, surchargeAmounts }: { props: TransactionPageProps; orderId: string; surchargeAmounts: SurchargeAmounts }) {
  const handleCreateCustomer = () => {
    const EMPTY_CUSTOMER_ID = -1
    window.location.href = (props.customer_id === EMPTY_CUSTOMER_ID)
      ? `${getLegacyDomain()}/mcust.pay?new=Y&tranxid=${orderId}`
      : `${getLegacyDomain()}/mcust.pay?tranxid=${orderId}&cid=${String(props.customer_id)}`
  }
  const navigate = useNavigate()

  return (
    <Fieldset className={'entire-view'}>
      <div className="uid-tranx-app-clear clear"></div>
      <div className="uid-tranx-app-success center success giant-text status-banner">Approved</div>

      <ResponseInformation
        title="Approval Information:"
        approvalCode={props.approval_code}
        responseMessage={`${props.approval_message} - Approved and completed`}
        orderId={orderId}
        amountDisplay={<AmountsDisplay props={props} surchargeAmounts={surchargeAmounts} />}
        actionButtons={
          <>
            <button className="action-btn" onClick={handleCreateCustomer}>Create Customer From Transaction</button>
            <button className="action-btn" onClick={props.onTransactionReprocess}>Reprocess Card</button>
          </>
        }
      />

      <br />

      <ViewAndEmailReceipt
        orderId={orderId}
        merchantId={props.merchant}
        initialEmails={props.emails}
      />
        <If is={props.showEnhancedData}>
            <ManageEnhancedDataBanner
                title="Manage Enhanced Data to help qualify for better rates."
                subText="In order for this transaction to be eligible for better processing rates, line item data is required. "
                buttonText="Manage Enhanced Data"
                onButtonClick={() => {
                  navigate(`${MANAGE_ENHANCED_DATA_PAGE_ROUTE}?tranxid=${orderId}`)
                }}
            />
        </If>

      <div className="warning warning-banner">
        <AlertIcon />
        &nbsp;Warning - Please do not click the back or refresh buttons as this may cause your transaction to be duplicated.
      </div>

    </Fieldset>
  )
}
